import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";

// reactstrap components
import {
  Alert,
  Button,
  CardBody,
  Form,
  Input,
  Container,
  Row,
  Col,
  FormGroup
} from "reactstrap";

// core components
import ColorNavbar from "components/Navbars/ColorNavbar.js";
import Logos from "./Logos.js"

const NOMBRE_COMPLETO_REGEX =
  /^[A-Za-zÁÉÍÓÚÜÑáéíóúüñ]+(?:['’-][A-Za-zÁÉÍÓÚÜÑáéíóúüñ]+)*(?:\s+[A-Za-zÁÉÍÓÚÜÑáéíóúüñ]+(?:['’-][A-Za-zÁÉÍÓÚÜÑáéíóúüñ]+)*)+$/;
const CORREO_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
const RECAPTCHA_SITE_KEY = "6LdkEO8tAAAAALA3qvrJPKW5ZY-RrtGIEgthZ9Nq";
const MINIMO_CARACTERES_MENSAJE = 30;
const MINIMO_PALABRAS_MENSAJE = 5;

function ContactUs() {
  const [nombres, setNombres] = React.useState("");
  const [correo, setCorreo] = React.useState("");
  const [mensaje, setMensaje] = React.useState("");
  const [captchaToken, setCaptchaToken] = React.useState(null);
  const [errorEmail, setErrorEmail] = React.useState({
    mostrar: false,
    tipo: "danger",
    message: "",
  });
  const recaptchaRef = React.useRef(null);
  const notaria = useSelector((state) => state.notaria.notaria);

  const obtenerErrorMensaje = (texto) => {
    const textoLimpio = texto.trim();
    const cantidadCaracteres = textoLimpio.length;
    const cantidadPalabras = textoLimpio ? textoLimpio.split(/\s+/).length : 0;
    const caracteresFaltantes = Math.max(0, MINIMO_CARACTERES_MENSAJE - cantidadCaracteres);
    const palabrasFaltantes = Math.max(0, MINIMO_PALABRAS_MENSAJE - cantidadPalabras);
    const requisitosFaltantes = [];

    if (caracteresFaltantes > 0) {
      requisitosFaltantes.push(
        `${caracteresFaltantes} ${caracteresFaltantes === 1 ? "carácter" : "caracteres"}`
      );
    }
    if (palabrasFaltantes > 0) {
      requisitosFaltantes.push(
        `${palabrasFaltantes} ${palabrasFaltantes === 1 ? "palabra" : "palabras"}`
      );
    }

    return requisitosFaltantes.length > 0
      ? `El mensaje requiere ${requisitosFaltantes.join(" y ")} más.`
      : "";
  };

  const enviarCorreo = async (e) => {
    e.preventDefault();

    const nombreLimpio = nombres.trim();
    const correoLimpio = correo.trim();
    const mensajeLimpio = mensaje.trim();

    if (!NOMBRE_COMPLETO_REGEX.test(nombreLimpio)) {
      setErrorEmail({
        mostrar: true,
        tipo: "danger",
        message: "Escriba un nombre completo con al menos dos palabras.",
      });
      return;
    }
    if (!CORREO_REGEX.test(correoLimpio)) {
      setErrorEmail({
        mostrar: true,
        tipo: "danger",
        message: "Escriba un correo electrónico válido.",
      });
      return;
    }

    const errorMensaje = obtenerErrorMensaje(mensajeLimpio);
    if (errorMensaje) {
      setErrorEmail({ mostrar: true, tipo: "danger", message: errorMensaje });
      return;
    }
    if (!captchaToken) {
      setErrorEmail({
        mostrar: true,
        tipo: "danger",
        message: "Debe completar la verificación “No soy un robot”.",
      });
      return;
    }

    try {
      const config = {
        method: "POST",
        mode: "cors",
        headers: {
          "Access-Control-Allow-Origin": true,
          Authorization: "Bearer " + process.env.REACT_APP_TOKEN_API,
        },
      };
      const data = {
        remitente_name: nombreLimpio,
        remitente_email: correoLimpio,
        descripcion: mensajeLimpio,
        destinatario: notaria.email_contactenos,
      };
      const resultado = await Axios.post(
        process.env.REACT_APP_UrlApi + "MailContact",
        data,
        config
      );

      if (resultado.status === 200) {
        setNombres("");
        setCorreo("");
        setMensaje("");
        setCaptchaToken(null);
        if (recaptchaRef.current) {
          recaptchaRef.current.reset();
        }
        setErrorEmail({
          mostrar: true,
          tipo: "success",
          message: "Correo Enviado, pronto le daremos una respuesta",
        });
      } else {
        setErrorEmail({
          mostrar: true,
          tipo: "danger",
          message: "Sucedió un error, intentarlo mas tarde",
        });
      }
    } catch (error) {
      setErrorEmail({
        mostrar: true,
        tipo: "danger",
        message: "Sucedió un error, intentarlo mas tarde",
      });
    }
  };

  return (
    <>
      <ColorNavbar />
      <div className="main" id="contact-us">
        <div className="section section-gray">
          <Container>
            <Row>
              <Col className="ml-auto mr-auto text-center" md="8">
                <h2 className="title">Para mayor información</h2>
                <p className="font-weight-normal mt-2">
                  Visite nuestras oficinas o comuníquese con nuestras líneas de
                  atención al cliente para recibir información adicional.
                </p>
              </Col>
            </Row>
            <Row>
              <Col 
                className="ml-auto mr-auto text-center" md="6"> 
              </Col>
            </Row>
            <Row>
              <Col className="ml-auto mr-auto text-center mt-5" md="6">
                <Form className="contact" id="contact-form" noValidate onSubmit={enviarCorreo}>
                  <Row className="my-2">
                    <Col>
                      <Input
                        placeholder="Nombre completo"
                        type="text"
                        value={nombres}
                        onChange={(e) => setNombres(e.target.value)}
                      />
                    </Col>
                  </Row>
                  <Row className="my-2">
                    <Col>
                      <Input
                        placeholder="Correo Electronico"
                        type="email"
                        value={correo}
                        onChange={(e) => setCorreo(e.target.value)}
                      />
                    </Col>
                  </Row>
                  <Input
                    placeholder="Mensaje"
                    rows="7"
                    type="textarea"
                    value={mensaje}
                    onChange={(e) => setMensaje(e.target.value)}
                  />
                  <Row className="my-3">
                    <Col>
                      <FormGroup>
                        <ReCAPTCHA
                          ref={recaptchaRef}
                          sitekey={RECAPTCHA_SITE_KEY}
                          onChange={setCaptchaToken}
                          onExpired={() => setCaptchaToken(null)}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  {errorEmail.mostrar && (
                    <Row className="my-3 justify-content-center" id="mostrar">
                      <Col md="10">
                        <Alert color={errorEmail.tipo} className="font-weight-normal text-center">
                          {errorEmail.message}
                        </Alert>
                      </Col>
                    </Row>
                  )}
                  <Row className="my-3">
                    <Col className="ml-auto mr-auto" md="7">
                      <Button
                        type="submit"
                        className="btn-round"
                        style={{
                          borderColor: "#64bb46",
                          backgroundColor: "#64bb46",
                          color: "white"
                        }}
                      >
                        Enviar Mensaje
                      </Button>
                    </Col>
                  </Row>
                  <Row style={{marginTop:'-22px'}} >
                    <Col md="8" className="text-center ml-auto mr-auto mb-5">
                      <h4 className="mb-4">Atención al Público</h4>
                      <Button
                        className="btn-rotate btn-block btn-round mr-1 "
                        color="default"
                        to="/pqrs" tag={Link}
                      >
                        <i className="fa fa-hand-pointer-o" aria-hidden="true"></i>
                        PQRS
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Col>
              <Col className="ml-auto" md="5">
                <CardBody
                  className="py-4"
                  style={{ padding: "24px", marginLeft: "-16px", backgroundColor:"white", borderRadius:"20px", marginBottom:"20px"}}
                >
                  <div className="info info-horizontal">
                    <div className="icon icon-warning">
                      <i className="nc-icon nc-pin-3" />
                    </div>
                    <div className="description">
                      <h5 className="info-title font-weight-normal">
                        Estamos ubicados
                      </h5>
                      <p
                        className="font-weight-normal"
                        style={{ color: "#75706F" }}
                      >
                        Cra 21 N° 22 - 30 Bucaramanga, Colombia <br />
                        Horarios de atención: <br />
                        Lunes a jueves 7:30am - 1:00 y de 2:00 - 5:00pm <br />
                        Viernes: 7:30am - 12:30 y de 2:00 - 5:00pm <br />
                        Sábados de turno: 8:00am a 12:00pm <br />
                        Septiembre 6<br />
                        Octubre 11<br />
                        Noviembre 15<br />
                        Diciembre 20<br />
                      </p>
                      <p
                        className="font-weight-normal"
                        style={{ color: "#75706F" }}
                      >
                      </p>
                    </div>
                  </div>
                  <div className="info info-horizontal">
                    <div className="icon icon-danger">
                      <i className="nc-icon nc-badge" />
                    </div>
                    <div className="description">
                      <h5 className="info-title font-weight-normal">
                        Contacto
                      </h5>
                      <p
                        className="font-weight-normal"
                        style={{ color: "#75706F" }}
                      >
                        TELEFONO FIJO: 607 6984777<br />
                        CEL : 317 513 0082
                        <br />
                      </p>
                      <p
                        className="font-weight-normal"
                        style={{ color: "#75706F" }}
                      >
                        Email: <br />
                        <span>decimabucaramanga@supernotariado.gov.co</span>
                        <br />
                        <span>notariadecimabucaramanga@gmail.com</span>
                      </p>
                    </div>
                    <div>
                      <Row className="my-4">
                        <Col md="6" sm="4">
                          <div className="">
                            <a
                              target="_blank"
                              rel="noopener noreferrer"
                              href="https://www.waze.com/es/livemap/directions/colombia/santander/bucaramanga/notaria-10?place=ChIJkYU5X3sVaI4Ra6LpuYb9BTI"
                            >
                              <img
                                alt="Logo de la aplicación Wazw"
                                src={require("assets/img/sections/waze-logo.png")}
                                className=" waze"
                              ></img>
                            </a>
                          </div>
                        </Col>
                        <Col md="6" sm="4">
                          <div className="">
                            <a
                              target="_blank"
                              rel="noopener noreferrer"
                              href="https://www.google.com/maps/dir/?api=1&destination=Notaria+10,+Cra.+21+%2322-30,+Bucaramanga,+Santander"
                            >
                              <img
                                alt="Logo de Google Maps"
                                src={require("assets/img/sections/maps.png")}
                                className="maps"
                              ></img>
                            </a>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </CardBody>
              </Col>
            </Row>
            <Row>
              <Col className="col-sm-12" md="12" style={{ marginLeft: "-3vh" }}>
                <div className="" id="contactUsMap2">
                  <iframe
                    title="map"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3958.9957622793745!2d-73.12639868573154!3d7.126485317837901!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e68157b5f398591%3A0x3205fd86b9e9a26b!2sNotaria%2010!5e0!3m2!1ses!2sco!4v1595441843968!5m2!1ses!2sco"
                    width="1150"
                    height="200"
                    frameBorder="0"
                    style={{ border: 0 }}
                    aria-hidden="false"
                    tabIndex="0"
                  ></iframe>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
      <Logos/>
    </>
  );
}

export default ContactUs;
